export default "__VITE_ASSET__a7729594__"